import React, { FunctionComponent } from 'react';
import { Table } from 'components';
import styled from 'styled-components';

export const StyledInnerTable = styled(Table)`
  &&&& .ant-table {
    margin-left: 0;
  }
`;

export const StyledMobileColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledMobileTableCell = styled.td<{ column?: boolean }>`
  & > div > div {
    display: flex;
    ${({ column }) =>
      column ? 'flex-direction: column; align-items: flex-start;' : ''}
    margin: 4px 0;
    &:first-child {
      margin-top: 0;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  & > div > button {
    align-self: flex-start;
  }
`;

const TourTableCell = 'border-bottom: 1px solid #ffffff !important;';

export const StyledTourTableCell = styled.td`
  ${TourTableCell}
`;

export const StyledMobileTourTableCell = styled(StyledMobileTableCell)`
  ${TourTableCell}
`;
